__turbopack_context__.v({
  "bannerItem": "ydQLAG_bannerItem",
  "bannerWrapper": "ydQLAG_bannerWrapper",
  "divider": "ydQLAG_divider",
});
